import { useMetricMetaStore } from "@client/store/metricMeta";
import { useValuesStore } from "@client/store/values";

/**
 * Vrátí metadata MQTT topicu — nickname, unit, decimals, valueType.
 *
 * Priorita zdrojů:
 *   1. metricMetaStore (boot fetch z /api/mqtt/topics-meta, plus WS upsert udržuje cache aktuální)
 *   2. fallback na bundlované topic z poslední WS hodnoty (kdyby topic v DB nebyl vůbec — vzácné)
 *
 * Komponenty BMS/PIP/Tracer díky tomu mají label/unit/decimals okamžitě po loginu,
 * bez čekání na první MQTT throttle interval.
 */
export const useMetricMeta = (topicId: string | undefined): MQTTTopic | undefined => {
  const fromCache = useMetricMetaStore((s) => (topicId ? s.meta.get(topicId) : undefined));
  const fromValue = useValuesStore((s) => (topicId ? s.byTopic.get(topicId)?.topic : undefined));
  return fromCache ?? fromValue;
};
